
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investor-relations",
      function () {
        return require("private-next-pages/investor-relations.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/investor-relations"])
      });
    }
  